export interface InventoryRow {
  id: string;
  name: string;
  unitsSold: number;
  availableUnits: number | null;
  /** Optional parent item id — used to group/filter rows when the modal aggregates multiple items */
  parentId?: string;
  /** Optional parent item display name — shown as a breadcrumb prefix before the variant name */
  parentName?: string;
}

export const computeInventoryTotals = (rows: InventoryRow[]): { totalAvailable: number | null; totalSold: number } => {
  let totalAvailable = 0;
  let totalSold = 0;
  let hasAvailable = false;
  for (const row of rows) {
    totalSold += row.unitsSold;
    if (row.availableUnits !== null) {
      totalAvailable += row.availableUnits;
      hasAvailable = true;
    }
  }
  return { totalAvailable: hasAvailable ? totalAvailable : null, totalSold };
};

export const computeAvailableUnitsDiff = (
  originalAvailableUnits: number | null,
  currentAvailableUnits: number | null
): number => {
  if (currentAvailableUnits === null || originalAvailableUnits === null) {
    return 0;
  }
  return currentAvailableUnits - originalAvailableUnits;
};
